import { toast } from 'sonner';
import { ApiNetworkError, ApiServerError } from '@/lib/api-client';

/**
 * Toast a mutation failure with its (friendly, backend-provided) message — but stay
 * SILENT for server (5xx) and network errors. Those are already surfaced by the
 * global query-client handler ("Something went wrong on our end" / "Can't reach the
 * server"); toasting them here too would double-fire AND leak a techy
 * "HTTP 500" / "Failed to fetch" string. For ordinary 4xx the backend's `detail`
 * (e.g. "A working copy is already open for this document.") is the right message.
 */
export function toastMutationError(err: unknown, fallback: string): void {
  if (err instanceof ApiServerError || err instanceof ApiNetworkError) return;
  toast.error(err instanceof Error ? err.message : fallback);
}
